export default {
  ALIGNERS: 'ALIGNERS',
  BRACES: 'BRACES',
  UNASSIGNED: 'UNASSIGNED',
} as const
